const initialAppointmentsValues = {
  ConsultationReason: "",
  Status: undefined,
  DateFrom: "",
  // DateTo: "",
  Duration: "",
  Notes: "",
  Priority: 5,
  PatientID: "",
  EmployeeID: "",
};

export default initialAppointmentsValues;
